import { defineField, defineType } from 'sanity'
import VehicleInput2 from '../../components/VehicleInput2'

export default defineType({
  title: 'Vehicle',
  name: 'vehicle',
  type: 'document',
  fields: [
    defineField({
      name: 'search', // <- used for searching
      title: 'Search String',
      type: 'string',
      hidden: true,
      readOnly: true,
      initialValue: '',
    }),
    defineField({
      name: 'make',
      type: 'reference',
      to: [{ type: 'make' }],
    }),
    defineField({
      name: 'model',
      type: 'reference',
      to: [{ type: 'model' }],
    }),
    defineField({
      name: 'generation',
      type: 'reference',
      to: [{ type: 'generation' }],
    }),
    defineField({
      name: 'submodel',
      type: 'reference',
      to: [{ type: 'submodel' }],
    }),
  ],
  validation: (rule) =>
    rule.custom((vehicle) => {
      if (!vehicle?.make) return 'At least Vehicle make is required'
      return true
    }),
  components: {
    input: VehicleInput2,
  },
  preview: {
    select: {
      make: 'make.name',
      model: 'model.name',
      generation: 'generation.name',
      submodel: 'submodel.name',
    },
    prepare({ make = '', model = '', generation = '', submodel = '' }) {
      const title = [make, model, generation, submodel]
        .filter((v) => v !== '' && v !== null && v !== undefined)
        .join(' ')
      return {
        title,
      }
    },
  },
})